export const authorizedFetch = (url, options) => {

    var token = localStorage.getItem('token')
    if (token) {

      if (!options) {
        options = {}
      }

      if (!options.headers) {
        options.headers = new Headers()
      }

      options.headers.append('Authorization', "Bearer " + token);
    }

    return fetch(url, options)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js